/**
 * Remove all filters
 *
 * Will trigger new search
 *
 * @param except Array[String] field name of any filters that should remain
 */
export default function clearFilters() {
  var _console;
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (this.debug)
    // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, ["Search UI: Action", "clearFilters"].concat(Array.prototype.slice.call(arguments)));
  var filters = this.state.filters;
  var updatedFilters = filters.filter(function (filter) {
    var filterField = filter.field;
    return except.includes(filterField);
  });
  this._updateSearchResults({
    current: 1,
    filters: updatedFilters
  });
}